import React from 'react';
import { Link } from 'react-router-dom';

import { ProfitAndLossTemplate } from '../../components/Templates';
import { useProfitAndLoss } from '../../components/Accounts';
import { useAppContext } from '../../contexts/Storage';

const ProfitLossPage: React.FC = () => {
  const { selectedRecord } = useAppContext();

  const {
    mappedData,
    isLoading,
    hasRequiredParams,
    handleDateFilter,
  } = useProfitAndLoss();

  // Show message if no record is selected
  if (!selectedRecord) {
    return (
      <div className="h-shink-from-navbar h-fill-from-navbar px-2 bg-bg_grey_light text-dark">
        <div className="max-w-7xl mx-auto">
          <div className="p-6 bg-light rounded-lg flex flex-col items-center justify-center min-h-[200px]">
            <p className="text-grey_dark mb-4">Please select a record to view profit and loss.</p>
            <Link
              to="/records"
              className="text-primary hover:text-primary_dark underline"
            >
              Go to Records
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ProfitAndLossTemplate
      title="Profit and Loss"
      description="Profit and loss statement"
      data={mappedData}
      loading={isLoading && hasRequiredParams}
      onDateRangeChanged={handleDateFilter}
      debitSideTitle="DR"
      creditSideTitle="CR"
      emptyMessage="No profit and loss data available"
    />
  );
};

export default ProfitLossPage;
